import { createAction } from '@reduxjs/toolkit';

import { getFailurePayload, getRequestPayload, getSuccessPayload } from 'modules/utils';

import * as actionTypes from '../actionTypes';

export const payOnline = createAction(actionTypes.PAY_ONLINE, (url, advices) => ({
  payload: {
    request: {
      method: 'POST',
      url,
      ...(advices ? { data: { advices } } : {}),
    },
  },
}));
export const payOnlineSuccess = createAction(actionTypes.PAY_ONLINE_SUCCESS);
export const payOnlineFailure = createAction(actionTypes.PAY_ONLINE_FAILURE, getFailurePayload);

export const payDeposit = createAction(actionTypes.PAY_DEPOSIT, getRequestPayload({ method: 'POST' }));
export const payDepositSuccess = createAction(actionTypes.PAY_DEPOSIT_SUCCESS);
export const payDepositFailure = createAction(actionTypes.PAY_DEPOSIT_FAILURE, getFailurePayload);

/** @type {import('../types').PayFinalInvoiceAction} */
export const payFinalInvoice = createAction(actionTypes.PAY_FINAL_INVOICE, url => ({
  payload: {
    request: {
      method: 'POST',
      url,
    },
  },
}));

export const payFinalInvoiceSuccess = createAction(actionTypes.PAY_FINAL_INVOICE_SUCCESS);

/** @type {import('../types').PayFinalInvoiceFailureAction} */
export const payFinalInvoiceFailure = createAction(actionTypes.PAY_FINAL_INVOICE_FAILURE, getFailurePayload);

/** @type {import('../types').FetchPaymentsAction} */
export const fetchPayments = createAction(actionTypes.FETCH_PAYMENTS, getRequestPayload());

/** @type {import('../types').FetchPaymentsSuccessAction} */
export const fetchPaymentsSuccess = createAction(actionTypes.FETCH_PAYMENTS_SUCCESS, getSuccessPayload);

/** @type {import('../types').FetchPaymentsFailureAction} */
export const fetchPaymentsFailure = createAction(actionTypes.FETCH_PAYMENTS_FAILURE, getFailurePayload);
